(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    const form = document.getElementById('password-form');
    const button = form?.querySelector('.password-form-button');
    const input = form?.querySelector('#password-input');

    if (!form || !button || !input) return;

    // Handle form submission
    form.addEventListener('submit', function (e) {
      if (input.value.trim() === '') {
        e.preventDefault();
        input.focus();
        return false;
      }

      // Add loading state
      button.classList.add('loading');
      button.disabled = true;

      // Re-enable after 5 seconds as fallback (form should submit before this)
      setTimeout(function () {
        button.classList.remove('loading');
        button.disabled = false;
      }, 5000);
    });

    // Clear errors when user starts typing
    input.addEventListener('input', function () {
      const errors = form.querySelector('.section-password__error');
      if (errors) {
        errors.style.display = 'none';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
